import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  getAccountAgentCommandEventsStats,
  getOrganizationAgentCommandEventsStats,
} from '@kirin/api-client/api/agent-command-events';
import type { AgentCommandEventsStats } from '@kirin/api-client/contracts/agent-command-events';
import { apiClient } from '@/lib/api-client';

/**
 * Summary stat cards for the Agents Activity → Packages & Repos screen
 * (KIR-3483). When `organizationId` is provided the org-scoped stats are
 * fetched; otherwise the current user's personal stats. Kept fresh-ish (30s)
 * since it feeds passive dashboard cards.
 */
export function useAgentCommandEventsStats(
  organizationId?: string
): UseQueryResult<AgentCommandEventsStats> {
  return useQuery({
    queryKey: [
      'agent-command-events',
      organizationId ?? 'account',
      'stats',
    ] as const,
    queryFn: () =>
      organizationId
        ? getOrganizationAgentCommandEventsStats(apiClient, organizationId)
        : getAccountAgentCommandEventsStats(apiClient),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
